import { render, staticRenderFns } from "./CustomerTagsInput.vue?vue&type=template&id=34e50b03&"
import script from "./CustomerTagsInput.vue?vue&type=script&lang=js&"
export * from "./CustomerTagsInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTagsInput.vue?vue&type=style&index=0&id=34e50b03&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports